import CtaSection from './CtaSection';

export { type CtaSectionProps } from './CtaSection';
export default CtaSection;
